"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MasterarbeitTags = _interopRequireDefault(require("./MasterarbeitTags/MasterarbeitTags"));
var _TextWithSyllabification = _interopRequireDefault(require("../../../SIA-WEBSITE/TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.MasterarbeitTop-container h1,\n.MasterarbeitTop-container h2,\n.MasterarbeitTop-container h3,\n.MasterarbeitTop-container p {\n  max-width: 648px; }\n\n@media (max-width: 66rem) {\n  .MasterarbeitTop-container h1,\n  .MasterarbeitTop-container h2,\n  .MasterarbeitTop-container h3,\n  .MasterarbeitTop-container p {\n    max-width: 452px; } }\n";
  const fileName = "MasterarbeitTop_MasterarbeitTop";
  const element = document.querySelector("style[data-sass-component='MasterarbeitTop_MasterarbeitTop']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getAuthors = authors => {
  return authors?.map((author, i) => {
    const isFirst = i === 0;
    const title = author?.author_title || author.author_name?.title;
    const name = author.author_name?.name;
    const href = author.author_name?.email?.length > 0 ? 'mailto:' + author.author_name?.email : '';
    return /*#__PURE__*/_react.default.createElement("span", {
      key: i
    }, !isFirst && /*#__PURE__*/_react.default.createElement("span", null, "; "), href ? /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      style: {
        color: 'black'
      }
    }, name) : /*#__PURE__*/_react.default.createElement("span", {
      style: {
        textDecoration: 'underline'
      }
    }, name), title?.length > 0 && /*#__PURE__*/_react.default.createElement("span", null, ", ", title));
  }) || '';
};
const getFormattedDate = date => {
  const format = date.split('-');
  if (format.length !== 3) return '';
  const day = format[2];
  const month = format[1];
  const year = format[0];
  return `${day}.${month}.${year}`;
};
const MasterarbeitTop = _ref => {
  let {
    item
  } = _ref;
  const item_lead = item.lead && item.lead.replace('<p>', '')?.replace('</p>', '');
  const date = _react.default.useMemo(() => getFormattedDate(item.date), [item.date]);
  const authors = getAuthors(item.author);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "MasterarbeitTop-container"
  }, /*#__PURE__*/_react.default.createElement(_MasterarbeitTags.default, {
    item: item
  }), /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "sia-text-14 sia-margin-04-bottom"
  }, item.title?.replace('<p>', '')?.replace('</p>', '')), /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "sia-text-04 sia-margin-02-bottom"
  }, item_lead), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-border-01-bottom  sia-margin-02-bottom"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06 sia-margin-05-bottom"
  }, date, " / ", authors));
};
var _default = exports.default = MasterarbeitTop;